import React, { useState, useEffect, Fragment } from "react";
import Loader from "react-loader-spinner";
import Table from "react-bootstrap/Table";
import Switch from "react-switch";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import NominationTableHead from "../../superAdminReusable/reusableTable/reusableTableHeader/NominationTableHead";
import { NominationTableBody } from "../../superAdminReusable/reusableTable/reusableTableBody/NominationTableBody";
import BasicPagination from "../../../Pagination/Pagination";
import { SmallLoader } from "../../../Loader/SmallLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import {
  getAllRestaurantNominations,
  onChangeNominationStatus,
} from "../../../../store/actions/SuperAdminActions/commonSuperAdmin";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Button, Form, Image } from "react-bootstrap";
import {
  FormControl,
  IconButton,
  Select,
  TextField,
  Paper,
  InputBase,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { toTimestamp } from "../../../../function/common";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from "../../../reusableComponents/selectFilter";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import SearchIcon from "@material-ui/icons/Search";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import isEmpty from "../../../../store/validation/is-Empty";

const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const SuperAdminMainNominations = (props) => {
  //state
  const [loading, setLoading] = useState(false);
  const token = props.auth.user.accessToken;
  const [state, setState] = useState({
    registeredToggle: false,
    anchorEl: null,
    restaurantReverse: "",
    location: "",
  });
  const [showFilter, handleShowFilter] = useState(false);

  /*********************************
   * @DESC SELECTED DATE FILTER ACTION
   *********************************/
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onSuccessNominations = () => {
    // setLoading(false);
  };
  const onErrorNominations = () => {
    // setLoading(false);
    setCity("");
    setSignupStatus("All");
    setSignupStatusTwo("All");
    setStartDate("");
    setEndDate("");
    setStartDateTimeStamp("");
    setEndDateTimeStamp("");
    setSearch("");
    setState({
      ...state,
      location: "",
    });
  };

  const [search, setSearch] = useState("");
  const [searchFlag, setSearchFlag] = useState(false);
  const [sort, setSort] = useState(true);
  const [searchClick, setSearchClick] = useState(false);
  const [city, setCity] = useState("");
  const [signupStatus, setSignupStatus] = useState("All");
  const [signupStatusTwo, setSignupStatusTwo] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [startDateTimeStamp, setStartDateTimeStamp] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateTimeStamp, setEndDateTimeStamp] = useState("");
  const [sortByValue, setSortBy] = useState("Restaurant name");

  const onStartDateChange = (e) => {
    setStartDate(e.target.value);
    setStartDateTimeStamp(toTimestamp(e.target.value));
  };
  const onEndDateChange = (e) => {
    setEndDate(e.target.value);
    setEndDateTimeStamp(toTimestamp(e.target.value));
  };
  const sortByChangeCode = (event) => {
    const sortByValue = event.target.value;
    let startDate = "";
    let endDate = new Date();
    setSortBy(sortByValue);
    if (sortByValue === "Restaurant name") {
      setSort(true);
      setStartDate("");
      setEndDate("");
      setStartDateTimeStamp("");
      setEndDateTimeStamp("");
    } else if (sortByValue === "Today") {
      startDate = new Date();
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    } else if (sortByValue === "Last month") {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    } else if (sortByValue === "Last 3 months") {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    }
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    if (state.anchorEl) {
      setState({
        ...state,
        restaurantReverse: value,
        anchorEl: false,
      });
    }
  };

  const onCancelClick = () => {
    handleShowFilter(!showFilter);
    setCity("");
    setState({
      ...state,
      location: "",
    });
    setSignupStatus("All");
    setSignupStatusTwo("All");
    if (
      sortByValue !== "Today" ||
      !sortByValue !== "Last month" ||
      sortByValue !== "Last 3 months"
    ) {
      setStartDate("");
      setEndDate("");
      setStartDateTimeStamp("");
      setEndDateTimeStamp("");
    }
  };

  const onClickSearchSave = () => {
    handleShowFilter(!showFilter);
    if (signupStatus !== "All") {
      setSignupStatus(signupStatus);
      setSignupStatusTwo(signupStatus);
    } else {
      setSearchClick(!searchClick);
      setSignupStatus(signupStatus);
      setSignupStatusTwo(signupStatus);
      setState({
        ...state,
        location: city,
      });
    }
  };

  useEffect(() => {
    // setLoading(true);
    props.getAllRestaurantNominations(
      token,
      dateQuery.startDate,
      dateQuery.endDate,
      onSuccessNominations,
      onErrorNominations
    );
  }, [dateQuery]);

  const onChangeStatus = (id, status) => {
    const formData = {};
    formData.status = !status;
    props.onChangeNominationStatus(
      token,
      formData,
      id,
      onSuccessNominations,
      onErrorNominations
    );
  };
  const onSearchClick = (e) => {
    setSearch(e.target.value);
    e.target.value === "" && setSearchFlag(!searchFlag);
  };

  const filterData = props?.allRestaurantNominations;
  let filterDataArr = [];
  if (state?.restaurantReverse === "" && signupStatusTwo === "All") {
    filterDataArr =
      filterData &&
      filterData.filter((getall) => {
        return getall;
      });
  }
  if (state?.restaurantReverse === "A-Z") {
    filterDataArr = filterData.sort((a, b) => {
      if (a?.name.toLowerCase() < b?.name.toLowerCase()) return -1;
      if (a?.name.toLowerCase() > b?.name.toLowerCase()) return 1;
      return 0;
    });
  } else if (state?.restaurantReverse === "Z-A") {
    filterDataArr = filterData.sort((a, b) => {
      if (a?.name.toLowerCase() < b?.name.toLowerCase()) return 1;
      if (a?.name.toLowerCase() > b?.name.toLowerCase()) return -1;
      return 0;
    });
  }
  if (signupStatusTwo === "Active") {
    filterDataArr = filterData.filter((getall) => {
      return getall.status === true;
    });
  } else if (signupStatusTwo === "Inactive") {
    filterDataArr = filterData.filter((getall) => {
      return getall.status === false;
    });
  }
  if (!isEmpty(search)) {
    filterDataArr = filterData.filter((getall) => {
      return getall?.name.toLowerCase().includes(search.toLowerCase());
    });
  }
  if (!isEmpty(state.location)) {
    filterDataArr = filterData.filter((getall) => {
      let cityData = getall && getall?.vicinity.split(" ").slice(-1)[0];
      return cityData.toLowerCase().includes(state.location.toLowerCase());
    });
  }

  const renderTableDataBody = (nomination, index) => {
    return (
      <NominationTableBody
        id={nomination._id}
        //restaurantImage={require("../../../../assets/images/superadmin/marilend.png")}
        restaurantImage={nomination.icon}
        restaurantName={nomination.name}
        phoneNumber="+91 0000000000"
        address={nomination.vicinity}
        place={nomination.place_id}
        restaurantType={nomination.types.toLocaleString()}
        nomination={nomination.nomination.length}
        location={nomination.vicinity.split(",").slice(-2)[0]}
        city={nomination.vicinity.split(" ").slice(-1)[0]}
        reviewRateing={
          nomination?.rating !== undefined ? nomination?.rating : "N/A"
        }
        reviewTotalCount={
          nomination?.user_ratings_total !== undefined
            ? nomination?.user_ratings_total
            : "N/A"
        }
        reviewRateingData={nomination && nomination}
        viewIndex={index}
        registeredToggle={
          <Switch
            // onChange={handleChangeSwitch}
            //checked={state.registeredToggle}
            checked={nomination.status}
            offColor="#EEEEEE"
            onColor="#EEEEEE"
            offHandleColor="#212121"
            onHandleColor="#59F832"
            handleDiameter={24}
            uncheckedIcon={false}
            checkedIcon={false}
            height={15}
            width={41}
            boxShadow="-2px 0px 5px #0000003B"
            activeBoxShadow="-2px 0px 5px #0000003B"
            id="material-switch"
            onChange={() => onChangeStatus(nomination._id, nomination.status)}
          />
        }
        registeredToggleCss={state.registeredToggle}
      />
    );
  };

  return (
    <React.Fragment>
      {/* {!loading ? ( */}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="All Nominations" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div>
                  <div className="f24_700_HelveticaNeue">Nominations</div>
                  <p className="f10-400 opacity5">
                    Vew the list of Merchants and the list of users nominated to
                    the particular restaurant
                  </p>
                </div>
                <NavLink
                  to="/superadminnominationsdetailsactivity"
                  className="right-link f14-700"
                  style={{ color: "#F85032" }}
                >
                  View Nominations Activity
                </NavLink>
              </div>
              <div className="Col-12 p-0">
                <Filter
                  SortBy={sortByValue}
                  onSearchChange={onSearchClick}
                  onKeyDown={(e) =>
                    e.keyCode === 13 && setSearchClick(!searchClick)
                  }
                  sortByChangeCode={sortByChangeCode}
                  search={search}
                  handleShowFilter={() => {
                    handleShowFilter(!showFilter);
                  }}
                  arrData={filterDataArr}
                  openSortModal={handleClick}
                  anchorElState={state.anchorEl}
                  closedSortModal={handleClose}
                  handleSelectClick={(data) => handleSelect(data)}
                  dateTimeChange={onDateChangeHandler}
                />
              </div>
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <div className="row">
                      {/* <div className="col-6">
                        <div
                          className="d-flex justify-content-start"
                          style={{ alignItems: "center" }}
                        >
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onStartDateChange}
                            value={startDate}
                          />
                          &nbsp;To&nbsp;
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onEndDateChange}
                            value={endDate}
                          />
                        </div>
                      </div> */}
                      <div className="col-6">
                        {" "}
                        <Form.Group>
                          <Form.Control
                            type="text"
                            placeholder="Search by Location"
                            onChange={(e) => setCity(e.target.value)}
                            value={city}
                            className="amSearch"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-6">
                        <FormControl variant="outlined" className={`w-100`}>
                          <InputLabel id="signupStatus">
                            Signup Status
                          </InputLabel>
                          <Select
                            id="signupStatus"
                            label="Signup Status"
                            labelId="signupStatus"
                            name="signupStatus"
                            onChange={(e) => setSignupStatus(e.target.value)}
                            value={signupStatus}
                          >
                            <MenuItem value={""} disabled selected>
                              Select Signup Status
                            </MenuItem>
                            <MenuItem value={"All"}>ALL</MenuItem>
                            <MenuItem value={"Active"}>ACTIVE</MenuItem>
                            <MenuItem value={"Inactive"}>INACTIVE</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mt-4">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={onCancelClick}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={onClickSearchSave}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              <div className="user-table-reusable-superadmin table-responsive">
                <Table className="enOpenTicketsUsers HideShowTable">
                  <thead>
                    <NominationTableHead />
                  </thead>
                  {props?.auth?.secondary_loader ? (
                    <div className="text-center">
                      <Loader
                        type="Bars"
                        color="#00BFFF"
                        height={100}
                        width={100}
                      />
                    </div>
                  ) : filterDataArr && filterDataArr.length <= 0 ? (
                    <React.Fragment>
                      <div className="text-center">
                        <h3 className="f16-500 opacity5">NO RECORDS FOUND</h3>
                      </div>
                    </React.Fragment>
                  ) : (
                    !isEmpty(filterDataArr) &&
                    filterDataArr.length > 0 &&
                    filterDataArr
                      .slice(start, end)
                      .map((nomination, index) => (
                        <React.Fragment key={index}>
                          {renderTableDataBody(nomination, index)}
                        </React.Fragment>
                      ))
                  )}
                </Table>
              </div>
              {search !== "" ? (
                ""
              ) : (
                <div className="row w-100">
                  <div className="col-12">
                    {!isEmpty(filterDataArr) && filterDataArr.length !== 0 ? (
                      <BasicPagination
                        totalRecords={filterDataArr?.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* ) : (
        <AmealioLoader />
      )} */}
    </React.Fragment>
  );
};

SuperAdminMainNominations.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllRestaurantNominations: PropTypes.func.isRequired,
  onChangeNominationStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allRestaurantNominations:
    state.commonSuperAdmin.allRestaurantNominations?.data,
});

export default connect(mapStateToProps, {
  getAllRestaurantNominations,
  onChangeNominationStatus,
})(SuperAdminMainNominations);

export const Filter = (props) => {
  const paydownloadData = {
    headers: [
      { label: "Nomination ID", key: "id" },
      { label: "Restaurant Name", key: "name" },
      { label: "Address", key: "address" },
      { label: "City", key: "city" },
      { label: "Area / zip Code", key: "areaZipCode" },
      { label: "Place Id", key: "placeId" },
      { label: "Total Nominations", key: "totalNominations" },
      { label: "Signup Status", key: "status" },
      { label: "Location", key: "location" },
      { label: "Total Review \n Total Review Count", key: "review" },
      { label: "Business Status", key: "businessStatus" },
      { label: "Created Date", key: "date" },
    ],
    tabledata: props.arrData
      ? props.arrData?.map((ele) => {
          return {
            id: `${ele?._id}`,
            name: `${ele?.name}`,
            address: `${ele?.vicinity}`,
            city: `${ele?.vicinity.split(" ").slice(-1)[0]}`,
            areaZipCode: `${ele?.vicinity.split(",").slice(-2)[0]}`,
            placeId: `${
              ele?.place_id !== undefined && ele?.place_id !== null
                ? ele?.place_id
                : "N/A"
            }`,
            totalNominations: `${ele?.nomination.length}`,
            status: `${ele?.status ? "Active" : "Inactive"}`,
            location: `Latitude - ${ele?.location?.coordinates?.[1]} \n Longitude - ${ele?.location?.coordinates?.[0]}`,
            review: `Total Rating - ${
              ele?.rating !== undefined && ele?.rating !== null
                ? ele?.rating
                : "N/A"
            } \n Total Review Count ${
              ele?.user_ratings_total !== undefined &&
              ele?.user_ratings_total !== null
                ? ele?.user_ratings_total
                : "N/A"
            }`,
            businessStatus: `${
              ele?.business_status !== undefined &&
              ele?.business_status !== null
                ? ele?.business_status
                : "N/A"
            }`,
            date: `${moment(ele?.createdAt).format("Do MMM YYYY, hh:mm A")}`,
          };
        })
      : [],
  };

  const [displaySearch, setDisplaySearch] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const onClickSearchButtonTop = () => {
    setDisplaySearch(!displaySearch);
    setShowFilter(false);
  };

  const onClickDisplayFilter = (e) => {
    e.preventDefault();
    setShowFilter(!showFilter);
    setDisplaySearch(false);
  };

  return (
    <React.Fragment>
      <div className="row mt-3 mb-2">
        <div className="col-6">
          <div className="d-flex align-items-center">
            <Image
              alt="Search"
              title="Search"
              width="80px"
              src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
              onClick={() => onClickSearchButtonTop()}
            />
            <Image
              src={require("../../../../assets/images/iconButton/filterbtn.svg")}
              width="80px"
              alt="Filter"
              title="Filter"
              onClick={props.handleShowFilter}
            />
            <SortComponent
              handleClick={props.openSortModal}
              anchorEl={props.anchorElState}
              handleClose={props.closedSortModal}
              selectClick={props.handleSelectClick}
              displayOnlineOffers={"NOMINATION"}
            />
            <div className="f10-400" align="center">
              <CSVDownloader
                filename={"Restaurant_Nomination_Report"}
                headers={paydownloadData.headers}
                data={paydownloadData.tabledata}
              />
            </div>
          </div>
        </div>
        <div className="col-6 d-flex justify-content-end">
          <div className="col-7">
            <div className="mr-3">
              <SelectFilter onDateChange={props.dateTimeChange} />
            </div>
          </div>
        </div>
        <div className="col-5">
          {displaySearch ? (
            <React.Fragment>
              <ZoomDiv>
                <div className="mt-2">
                  <Form.Control
                    type="text"
                    placeholder="Search by Restaurant Name, Google Place ID & Press Enter"
                    onChange={props.onSearchChange}
                    onKeyDown={props.onKeyDown}
                    value={props.search}
                    className="amSearch"
                  />
                </div>
              </ZoomDiv>
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

const sortBy = [
  { id: 0, title: "Restaurant name" },
  { id: 1, title: "Today" },
  { id: 2, title: "Last month" },
  { id: 3, title: "Last 3 months" },
];
